import { render, staticRenderFns } from "./Gzh.vue?vue&type=template&id=4149fea5&scoped=true&"
import script from "./Gzh.vue?vue&type=script&lang=js&"
export * from "./Gzh.vue?vue&type=script&lang=js&"
import style0 from "./Gzh.vue?vue&type=style&index=0&id=4149fea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149fea5",
  null
  
)

export default component.exports